const designationDate = [
  {
    designation: "Ass. Software Engineer Trainee",
    description: "manager",
  },
  {
    designation: "Ass. Software Engineer",
    description: "eng",
  },
  {
    designation: "HR Executive-Trainee",
    description: "trainee",
  },
  {
    designation: " HR Executive",
    description: "hr",
  },
  {
    designation: "HR Manager",
    description: "manager",
  },
  {
    designation: "Lead Engineer",
    description: "Lead",
  },
  {
    designation: "Managing Director",
    description: "Dirct",
  },
  {
    designation: " Manager - Sales",
    description: "sale",
  },
  {
    designation: "Sales Executive",
    description: "Exc",
  },
  {
    designation: "Software Engineer",
    description: "eng",
  },
  {
    designation: "Sr. Software Engineer",
    description: "sr",
  },
  {
    designation: " Sr. Lead Engineer",
    description: "sr lead",
  },
];

const workPrimiseData = [
  {
    workPrimise: "On site", // work primise
    // type2: "manager",
  },
  {
    workPrimise: "Off Shore", // work primise
  },
  {
    workPrimise: "Contract compnay", // work primise,
  },
];

const rewardData = [
  {
    rewardId: 1,
    reward: "Team player", // Reward Description data
    rewardPoint: "10", //Reward point data
  },
  {
    rewardId: 2,
    reward: "Suppoter", // Reward Description data
    rewardPoint: "20", //Reward point data
  },
  {
    rewardId: 3,
    reward: "Best Employee", // Reward Description data
    rewardPoint: "30", //Reward point data
  },
  {
    rewardId: 4,
    reward: "Best Performer of the year", // Reward Description data
    rewardPoint: "40", //Reward point data
  },
];

const toProcessRewards = [
  {
    empId: 29,
    empName: "Waston",
    empProfileImg: "avatar-01.jpg",
    empDesignation: "Associate Software Engineer",
    redeemPoints: 1000,
    redeemDate: "05-25-2020",
    status: "pending",
  },
  {
    empId: 12,
    empName: "Dutch",
    empProfileImg: "nible.png",
    empDesignation: "Associate Software Engineer",
    redeemPoints: 8000,
    redeemDate: "05-15-2020",
    status: "pending",
  },
];

export { designationDate, workPrimiseData, rewardData, toProcessRewards };
